module.exports = __webpack_public_path__ + "static/media/exibex.2df6e664.gif";